export default __webpack_public_path__ + "static/media/kitchen5-beforeC-480w.f64af1a9.webp";